import { createSelector } from '@reduxjs/toolkit';
import { PersistState } from 'redux-persist';

import { GlobalState } from '../createStore';

export const selectPersist = (state: GlobalState) => state._persist;

export const selectRehydrated = createSelector(selectPersist, (state: PersistState) => state?.rehydrated);
